import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-10">
      <div className="container mx-auto px-4">
        {/* Subscription Section 
        <div className="bg-gradient-to-r from-orange-500 to-yellow-500 text-center py-6 rounded-lg mb-8">
          <h2 className="text-xl font-semibold mb-2">Gelişmeleri Öğren</h2>
          <p className="text-sm mb-4">Mail listemize katılarak gelişmelerden haberdar olabilirsiniz.</p>
          <div className="flex justify-center">
            <input
              type="email"
              placeholder="Mail adresinizi yazın."
              className="p-2 rounded-l-lg w-64 text-gray-800"
            />
            <button className="bg-black text-white px-4 py-2 rounded-r-lg">Mailimi Kaydet</button>
          </div>
        </div>
        */}

        {/* Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center md:text-left">
          {/* About Section */}
          <div>
          <a href="#" className="text-2xl font-bold text-[#D9D9D9]">Kocabay Tur</a>
            <p className="text-sm">
              Kocabay Tur olarak sektörde kaliteli hizmet anlayışımızla sizlere Personel Taşımacılığı, Öğrenci Taşımacılığı, Vip Transfer Hizmetleri sağlıyoruz.
            </p>
          </div>

          {/* Menu Section */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Menüler</h3>
            <ul className="text-sm space-y-2">
              <li><a href="/" className="hover:underline">Anasayfa</a></li>
              <li><a href="/hizmetlerimiz" className="hover:underline">Hizmetlerimiz</a></li>
              <li><a href="/hakkimizda" className="hover:underline">Hakkımızda</a></li>
              <li><a href="/iletisim" className="hover:underline">İletişim</a></li>
            </ul>
          </div>

          {/* Services Section */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Hizmetlerimiz</h3>
            <ul className="text-sm space-y-2">
              <li>Araç Kiralama</li>
              <li>Personel Taşımacılığı</li>
              <li>VIP Transfer Hizmeti</li>
              <li>Öğrenci Taşımacılığı</li>
              <li>Şoförlü Araç Kiralama</li>
            </ul>
          </div>

          {/* Address Section */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Adresimiz</h3>
            <ul className="text-sm space-y-2">
              <li> Cumhuryet mahales Atatürk caddes Şenel İş Merkez Polatlı / Ankara</li>
              <li><a href="mailto:ib.kocabay18@gmail.com" className="hover:underline">ib.kocabay18@gmail.com</a></li>
              <li><a href="tel:05445208442" className="hover:underline">0544 520 84 42</a></li>
              <li><a href="tel:05428392878" className="hover:underline">0542 839 28 78</a></li>
              <li><a href="tel:03126211818" className="hover:underline">0312 621 18 18</a></li>
              <li><a href="tel:05423983273" className="hover:underline">0542 398 32 73</a></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-8 border-t border-gray-600 pt-4 text-center text-sm">
          <div className="flex justify-center space-x-4 mt-4">
            <a href="https://m.facebook.com/kocabaytur/" className="hover:text-gray-400">Facebook</a>
            <a href="https://www.instagram.com/kocabaytur?igsh=MWZ6a3I5NTM3cTI2OQ%3D%3D&utm_source=qr" className="hover:text-gray-400">Instagram</a>
            <a href="https://wa.me/905423983273" className="hover:text-gray-400">WhatsApp</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
